import { render, staticRenderFns } from "./work.vue?vue&type=template&id=5ca38480&scoped=true"
import script from "./work.vue?vue&type=script&lang=js"
export * from "./work.vue?vue&type=script&lang=js"
import style0 from "./work.vue?vue&type=style&index=0&id=5ca38480&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca38480",
  null
  
)

export default component.exports